import { LOAD_CATALOG_SUCCEEDED, LOADING_CATALOG, LOAD_CATALOG_FAILED } from '../actions/catalogActions'

function catalogReducer(existing = {}, action) {
  switch(action.type) {
    case LOAD_CATALOG_SUCCEEDED:
      return {
        items: action.payload
      }
    case LOADING_CATALOG:
      return {
        ...existing,
        loading: true,
      }
    case LOAD_CATALOG_FAILED:
      return {
        ...existing,
        loading: false,
      }

    default:
      return existing
  }
}

export default catalogReducer